import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { AISummaryFooterProps } from '../src/shared-components/AISummaryFooter.tsx';

export const AISummaryFooter: LoadableType<AISummaryFooterProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AISummaryFooter" */ '../src/shared-components/AISummaryFooter.tsx'
			)
		).AISummaryFooter,
});
